import { createAsyncThunk } from '@reduxjs/toolkit';
import { GeneralFaqAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  IGetGeneralFaqsDTO,
  IGetGeneralFaqsResponse,
  ICreateGeneralFaqDTO,
  ICreateGeneralFaqResponse,
  IUpdateGeneralFaqDTO,
  IDeleteGeneralFaqsDTO,
} from '@/models/generalFaq.model';
import { SLICE_NAME } from './models';

export const getGeneralFaqs = createAsyncThunk<
  IGetGeneralFaqsResponse,
  IGetGeneralFaqsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getGeneralFaqs`,
  async (params) => {
    const response = await GeneralFaqAPI.getGeneralFaqs(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateGeneralFaq = createAsyncThunk<
  ICreateGeneralFaqResponse,
  IUpdateGeneralFaqDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updateGeneralFaq`,
  async (data) => {
    const response = await GeneralFaqAPI.updateGeneralFaq(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createGeneralFaq = createAsyncThunk<
  ICreateGeneralFaqResponse,
  ICreateGeneralFaqDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/createGeneralFaq`,
  async (data) => {
    const response = await GeneralFaqAPI.createGeneralFaq(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteGeneralFaqs = createAsyncThunk<void, IDeleteGeneralFaqsDTO, { serializedErrorType: IApiError }>(
  `${SLICE_NAME}/deleteGeneralFaqs`,
  async (data) => {
    const response = await GeneralFaqAPI.deleteGeneralFaqs(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
